
/*
	This function care for the value that need to be printed for the tooltips;
	value: must be the exact value that comes from the BE
*/
const calculateFireRisk = (value) => {
	return (value * 10).toFixed(1);
};

export default calculateFireRisk;
